import { DefaultRoutineActions } from '@pvolve/sdk/src/app/utils';
import { createActions } from 'redux-actions';
import { DefaultRoutine } from 'src/utils/redux';
import { onRouteUpdate } from './segment-tracker/types';

export interface SegmentActions {
    segment: {
        load: DefaultRoutineActions<{ location: onRouteUpdate['location'] }>;
    };
}

const Actions = (createActions({
    SEGMENT: {
        LOAD: DefaultRoutine,
    },
}) as unknown) as SegmentActions;

export default Actions;
